import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IUICustomizationSettingsDTO, IUICustomizationViewCategorySettingsDTO } from "../../services/ui-customization-data-service/Models";

export function getCustomizationViewCategorySettings(
    objectType: eLynxObjectTypeEnum,
    customizationSettings: IUICustomizationSettingsDTO | undefined): IUICustomizationViewCategorySettingsDTO | undefined {
    return objectType === eLynxObjectTypeEnum.Group
        ? customizationSettings?.navigationDrawer?.viewCategories.group
        : objectType === eLynxObjectTypeEnum.Device
            ? customizationSettings?.navigationDrawer?.viewCategories.device
            : objectType === eLynxObjectTypeEnum.Well
                ? customizationSettings?.navigationDrawer?.viewCategories.well
                : objectType === eLynxObjectTypeEnum.TankBattery
                    ? customizationSettings?.navigationDrawer?.viewCategories.tankBattery
                    : objectType === eLynxObjectTypeEnum.Tank
                        ? customizationSettings?.navigationDrawer?.viewCategories.tank
                        : objectType === eLynxObjectTypeEnum.Tag
                            ? customizationSettings?.navigationDrawer?.viewCategories.tag
                            : undefined;
}
